import React from 'react';
import { cn } from '@/utils/common_functions';

interface RadioProps {
  label: string;
  value: string;
  onChange: (checked: boolean) => void;
  checked: boolean;
  disabled: boolean;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
}

export const Radio: React.FC<RadioProps> = props => {
  const {label, value, onChange, checked, disabled, className, labelClassName, inputClassName} = props;
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <input className={cn("size-4 cursor-pointer accent-ui_blue", inputClassName)} type="radio" value={value} onChange={e => onChange(e.target.checked)} checked={checked} disabled={disabled} />
      <label htmlFor={value} className={cn("text-ui_blue", labelClassName)}>{label}</label>
    </div>
  );
};
